type SocialPlatform = 'facebook' | 'zalo'

export function share(platform: SocialPlatform, title: string, url: string) {
  if (navigator.share) {
    navigator.share({
      title,
      url,
    })
  } else {
    shareToSocial(platform, url)
  }
}

export function shareToSocial(platform: SocialPlatform, href: string) {
  switch (platform) {
    case 'facebook':
      return window.open(`https://www.facebook.com/sharer/sharer.php?u=${href}`)
    case 'zalo':
      return window.open(`https://sp.zalo.me/share?href=${href}`)
    default:
      return null
  }
}
